import {
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { SuiIconComponent, SuiTooltipDirective } from '@stride-ui/components';
import { TranslateModule } from '@ngx-translate/core';
import { INavItem } from '@tnq/shared/types';

@Component({
  selector: 'tnq-nav-item',
  imports: [
    SuiIconComponent,
    TranslateModule,
    RouterModule,
    SuiTooltipDirective,
  ],
  templateUrl: './nav-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './nav-item.component.scss',
})
export class NavItemComponent {
  readonly router = inject(Router);

  item = input<INavItem>({ link: 'link', label: 'label', icon: 'icon' });
  isNarrowDisplay = input<boolean>(false);

  navigateTo(target: string): void {
    this.router.navigate([target]);
  }
}
